customElements.get("dbtfy-faq") ||
  customElements.define(
    "dbtfy-faq",
    class extends HTMLElement {
      constructor() {
        super();
        this.questions = this.querySelectorAll(".dbtfy-faq-question-wrapper");
        this.searchBar = this.querySelector(".dbtfy-faq-search-bar .search__input");
        this.searchEnabled = this.dataset.searchEnabled;
      }

      connectedCallback() {
        this.init();
      }

      init() {
        this.faqActive();
        if (this.searchEnabled === "true") this.initSearch();
      }

      faqActive() {
        this.questions.forEach((wrapper) => {
          const button = wrapper.querySelector(".dbtfy-faq-question-block");
          if (!button) return;

          const startActive = wrapper.classList.contains("dbtfy-faq-active");
          button.setAttribute("aria-expanded", startActive ? "true" : "false");

          button.addEventListener("click", () => {
            const nowActive = wrapper.classList.toggle("dbtfy-faq-active");
            button.setAttribute("aria-expanded", nowActive ? "true" : "false");
          });
        });
      }

      initSearch() {
        this.searchBar.addEventListener("input", () => {
          const term = this.searchBar.value.toLowerCase();
          let anyMatch = false;

          this.questions.forEach((wrapper) => {
            const question = wrapper.querySelector(".dbtfy-faq-question");
            const matches = question && question.innerText.toLowerCase().includes(term);
            wrapper.style.display = matches ? "block" : "none";
            if (matches) anyMatch = true;
          });

          document.querySelectorAll(".dbtfy-faq-group-block").forEach((group) => {
            const visible = group.querySelectorAll(
              '.dbtfy-faq-question-wrapper[style="display: block;"]'
            );
            group.style.display = visible.length > 0 ? "block" : "none";
          });

          const noResult = document.querySelector(".dbtfy-faq-no-result");
          if (noResult) noResult.style.display = anyMatch ? "none" : "block";
        });
      }
    }
  );
